module.exports = __webpack_public_path__ + "static/media/badges-user-card.be1c14c6.png";